import React, { useEffect, useRef, useState } from 'react';
import { Cog6ToothIcon } from '../../icons';

const TableColumnToggle = ({ columns, visibleKeys, onToggle, label = 'Columns' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="md-btn md-btn-outline md-btn-sm inline-flex items-center gap-1.5 whitespace-nowrap"
        aria-label={label}
        title={label}
      >
        <Cog6ToothIcon className="h-4 w-4" />
        <span className="hidden sm:inline">{label}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 z-[80] min-w-[180px] bg-white border border-matdash-border rounded-md-lg shadow-matdash py-2">
          {columns.map((col) => (
            <label
              key={col.key}
              className="flex items-center gap-2 px-3 py-2 text-sm text-matdash-dark hover:bg-matdash-primary-subtle/50 cursor-pointer"
            >
              <input
                type="checkbox"
                checked={visibleKeys.includes(col.key)}
                onChange={() => onToggle(col.key)}
                className="rounded border-matdash-border text-matdash-primary focus:ring-matdash-primary"
              />
              {col.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default TableColumnToggle;
